<template>
  <el-dialog class="customDialog addFolder" width="460px" title="新建文件夹" :visible.sync="isShow" :close-on-press-escape = 'false' :close-on-click-modal="false" @close="onClose">
    <el-form :model="formInline" :rules="rules" ref="form" label-width="110px" class="small-form">
      <el-form-item label="文件夹名称：" prop="name">
        <el-input class="form-short" v-model.trim="formInline.name" placeholder="请输入20字以内" :maxlength="20" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="所属文件夹：">
        <!-- <el-select class="form-short" v-model="formInline.folderId" filterable clearable placeholder="请选择">
          <el-option v-for="item in folderOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select> -->
        <TreeSelect class="form-short" v-model="formInline.folderId" filterable clearable :options="filtedFolderTree" :props="folderProps" placeholder="请选择"></TreeSelect>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="default" @click="onClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addFolder } from '@/api/marker'
import TreeSelect from '@/components/TreeSelect/TreeSelect'
import { mapGetters } from 'vuex'
export default {
  name: 'AddFolder',
  components: {
    TreeSelect
  },
  computed: {
    ...mapGetters(['folderTree']),
    filtedFolderTree () {
      const data = JSON.parse(JSON.stringify(this.folderTree))
      this.treeDeepForeach(data, 'children', 0)
      return data
    }
  },
  data () {
    return {
      isShow: false,
      formInline: {
        name: '',
        folderId: undefined
      },
      folderProps: {
        value: 'id',
        label: 'name',
        children: 'children'
      },
      rules: {
        name: [
          { required: true, message: '请输入文件夹名称', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入20字以内', trigger: 'blur' }
        ]
        // folderId: [
        //   { required: true, message: '请选择所属文件夹', trigger: 'blur' }
        // ]
      },
      folderOptions: [],
      // 表单列表
      tableList: [],
      loading: false
    }
  },
  mounted () {},
  methods: {
    open (id) {
      this.isShow = true
      // this.getFolderList()
    },
    clear () {
      this.formInline = this.$options.data().formInline
      this.$refs.form.clearValidate()
    },
    onClose () {
      this.clear()
      this.isShow = false
    },
    treeDeepForeach (data, childName, lastDeep) {
      for (let i = 0; i < data.length; i++) {
        data[i].deep = lastDeep
        data[i].disabled = lastDeep >= 3
        if (data[i][childName] && data[i][childName].length > 0) {
          lastDeep++
          this.treeDeepForeach(data[i][childName], childName, lastDeep)
        }
      }
    },
    // 获取文件夹列表
    // getFolderList () {
    //   getFolderTree({
    //     mapId: this.$route.query.mapId ? this.$route.query.mapId : 0
    //   }).then(res => {
    //     if (res.code === 200) {
    //       this.folderOptions = res.data
    //     }
    //   })
    // },
    onSubmit () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          const res = await addFolder({
            name: this.formInline.name,
            mapId: this.$route.query.mapId ? this.$route.query.mapId : 0,
            parentId: this.formInline.folderId
          }).catch(res => {
            this.loading = false
          })
          this.loading = false
          if (res.code === 200) {
            this.$Message('success', '创建文件夹成功')
            this.$emit('refresh')
            this.onClose()
          }
        } else {
          // this.$Message('error', '提交数据格式错误')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addFolder {
  margin-top: 15vh;
  .small-form{
    width: 370px;
  }
}
</style>
